export default ({
  evObj = {},
  evMore = {},
  evPage = {},
}) => {
  const tealium = window.teaTag || {};
  const dl = window.tealiumDl || {};

  const updated = {
    ...dl,
    ...evObj,
    ...evMore,
    page: {
      ...dl.page,
      ...evPage,
    },
  };

  if (tealium.view) {
    window.tealiumDl = JSON.parse(JSON.stringify(updated));
    tealium.view(JSON.parse(JSON.stringify(updated)));
  }
};
